<template>
  <div>
    <v-dialog v-model="dialog" max-width="400px" persistent>
      <v-card class="elevation-16 mx-auto">
        <v-card-title class="headline" primary-title>
          {{ $t('common.rate_user') + (targetUser ? targetUser.fullname : '')}}
        </v-card-title>

        <v-card-text>
          <div class="text-center mt-12">
            <v-rating v-model="rating"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$ratingFull"
              half-increments
              large
              hover
            ></v-rating>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="closeRate"> {{ $t('common.cancel') }}</v-btn>
          <v-btn color="primary" text @click="rateUser">
            {{ $t('common.rate') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import i18n from '@/plugins/i18n';

  export default {
    name: 'rate-dialog',

    components: {
    },

    data: ()=> ({
        rating: 5,
    }),

    props: {
        dialog: Boolean,
        targetUser: Object
    },

    methods: {
        closeRate() {
          this.$emit('closeDialog', false);
        },

        async rateUser() {
            try {
                const requestBody = {
                    targetUser: this.targetUser._id,
                    score: this.rating * 2, 
                    comment: ''
                }
                
                const response = await this.$http.post(process.env.VUE_APP_RATE_USER_API, requestBody);

                if (response.data && response.data.success) {
                    this.$fire({
                        title: i18n.t('common.rate_success'),
                        text: "",
                        type: "success"
                        }).then(() => {
                        this.closeRate();
                    });
                }
            } catch (e) {
                console.log(e.stack);
            }
        },
    }
  }
</script>
